import * as React from 'react';
import { TInfoBlocks } from './InfoBlocks.types';
import { infoBlocksData } from './InfoBlocks.constants';
import './InfoBlocks.styled.scss';

export const InfoBlocks: TInfoBlocks = () => {
  return (
    <div className="info-blocks">
      {infoBlocksData.map((block) => (
        <div key={block.id} className="info-blocks__item">
          <div className="info-blocks__item__icon">{block.icon}</div>
          <h3 className="info-blocks__item__title">{block.title}</h3>
          <p className="info-blocks__item__description">{block.description}</p>
        </div>
      ))}
    </div>
  );
};
